module.exports = __webpack_public_path__ + "img/south.be5030ca.webp";